export default __webpack_public_path__ + "static/media/midasi_point_en_pc@2x.b1c04991.png";